import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getToday } from "@/services/Utils";
import { FETCHING_ADD_DOWNLOAD } from "@/redux/types/main.types";
import useFilterStore from "@/stores/useFilterStore";

const OPTION_BY_TYPE = {
	purchase: "historial_compra",
	output: "historial_salida",
	in_use: "productos_en_uso",
	usage: "historial_entrada",
	other_movements: "otros_movimientos",
};

const FILE_NAME_BY_TYPE = {
	purchase: "historial_compra",
	output: "historial_salida",
	in_use: "productos_en_uso",
	usage: "historial_uso",
	other_movements: "otros_movimientos",
};

function buildLumenParams(type, storeFilter, appliedFilterParams) {
	const { estate_id, estate_parent_id, search, parameter } = storeFilter;

	const base = {
		search: search || "",
		parameter: parameter || "",
		estate_id: estate_id || "",
		estate_parent_id: estate_parent_id || "",
		defaultUnit: 1000,
	};

	if (type === "purchase") {
		return {
			...base,
			searchBusiness: appliedFilterParams.business_id || "",
			searchAptitud: appliedFilterParams.aptitude_id || "",
			dealer: appliedFilterParams.dealer_id || "",
			dateCreate: appliedFilterParams.date_from || "",
			dateCreateTo: appliedFilterParams.date_to || "",
			date: appliedFilterParams.date_from_document || "",
			dateTo: appliedFilterParams.date_to_document || "",
			type_currency: appliedFilterParams.type_currency || "",
			dealerNumber: "",
			deliveryNumber: "",
		};
	}

	if (type === "output") {
		return {
			...base,
			searchBusiness: appliedFilterParams.business_id || "",
			searchAptitud: appliedFilterParams.aptitude_id || "",
			businessCenter: appliedFilterParams.business_center_id || "",
			searchTypeOA: appliedFilterParams.type_oa_id || "",
			applicationOrder: appliedFilterParams.oa_code || "",
			searchTypeApplication: appliedFilterParams.type_movement_id || "",
			date: appliedFilterParams.date_from || "",
			dateTo: appliedFilterParams.date_to || "",
			type_currency: appliedFilterParams.type_currency || "",
		};
	}

	if (type === "in_use") {
		return {
			...base,
			businessCenter: appliedFilterParams.business_center_id || "",
			searchTypeOA: appliedFilterParams.type_oa_id || "",
			applicationOrder: appliedFilterParams.oa_code || "",
			searchTypeApplication: appliedFilterParams.type_movement_id || "",
			date: appliedFilterParams.date_from || "",
			dateTo: appliedFilterParams.date_to || "",
			type_currency: appliedFilterParams.type_currency || "",
			searchBusiness: "",
			searchAptitud: "",
			internalCode: "",
		};
	}

	if (type === "usage") {
		return {
			...base,
			businessCenter: appliedFilterParams.business_center_id || "",
			searchTypeOA: appliedFilterParams.type_oa_id || "",
			applicationOrder: appliedFilterParams.oa_code || "",
			searchTypeApplication: appliedFilterParams.type_movement_id || "",
			date: appliedFilterParams.date_from || "",
			dateTo: appliedFilterParams.date_to || "",
			type_currency: appliedFilterParams.type_currency || "",
			searchBusiness: "",
			searchAptitud: "",
			internalCode: "",
		};
	}

	if (type === "other_movements") {
		return {
			...base,
			estate_id: appliedFilterParams.estate_parent_id || estate_parent_id || "",
			date: appliedFilterParams.date_from || "",
			dateTo: appliedFilterParams.date_to || "",
		};
	}

	return base;
}

export function useHistoryExport(type, appliedFilterParams = {}) {
	const dispatch = useDispatch();
	const { filter } = useFilterStore();
	const downloads = useSelector((state) => state.main.downloads);
	const isExportingRef = useRef(false);

	const lumenOption = OPTION_BY_TYPE[type];

	const isAlreadyExporting = downloads?.some((download) => download.url === "/client/histories/export_excel" && download.params?.option === lumenOption);

	const handleExport = (optionData = "") => {
		if (isExportingRef.current || isAlreadyExporting) return;
		isExportingRef.current = true;
		setTimeout(() => {
			isExportingRef.current = false;
		}, 1000);

		const fileName = `${getToday()} ${FILE_NAME_BY_TYPE[type]}.xlsx`;
		const params = {
			...buildLumenParams(type, filter, appliedFilterParams),
			option: lumenOption,
			option_data: optionData,
		};

		dispatch({
			type: FETCHING_ADD_DOWNLOAD,
			payload: {
				file: {
					key: Array.from({ length: 25 }, () => Math.random().toString(36)[2] || "0").join(""),
					params,
					show: true,
					url: "/client/histories/export_excel",
					name: fileName,
					type: "excel",
					inExecution: false,
					inProgress: false,
					inChecked: false,
				},
			},
		});
	};

	return { handleExport, isAlreadyExporting };
}
